<template>
<nav id="bundle-nav">
  <ul class="nav nav-pills">
    <li>
      <router-link :to="{ name: 'create_bundle' }">Create Bundle</router-link>
    </li>
    <li v-if="bundleId">
      <router-link :to="{ name: 'edit_bundle', params: { bundleId: bundleId }}">Edit Bundle</router-link>
    </li>
    <li v-if="purchasableItemId">
      <router-link :to="{ name: 'purchasable_item', params: { purchasableItemId: purchasableItemId }}">Purchasable Item</router-link>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  props: ['bundleId', 'purchasableItemId']
}
</script>

<style scoped>
main nav {
  margin-bottom: 1em;
}

.nav {
  border-top: 0
}
</style>



// WEBPACK FOOTER //
// src/components/BundleNav.vue